import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { pricesByBillingIntervalAndPlan } from "~/constants";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useTrialDiscount } from "~/MemberApp/hooks";

export const useScheduledIntervalChange = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const trialDiscount = useTrialDiscount();
  const scheduledBillingInterval =
    currentUser?.subscription?.scheduledBillingInterval;
  const billingInterval = currentUser?.subscription?.billingInterval;
  const plan = currentUser?.subscription?.plan;
  const currentPeriodEnd = currentUser?.subscription?.currentPeriodEnd;
  const hasActivePartnerTrial = trialDiscount && !trialDiscount?.hasEnded;
  const currentPeriodEndFormatted =
    currentPeriodEnd &&
    DateTime.fromISO(currentPeriodEnd).toLocaleString(DateTime.DATE_SHORT);

  const planFormatted = plan && t(`common.plans.${plan}`);
  const conversationalInterval =
    billingInterval && t(`common.conversationalIntervals.${billingInterval}`);
  const conversationalUpcomingInterval =
    scheduledBillingInterval &&
    t(`common.conversationalIntervals.${scheduledBillingInterval}`);

  const priceByIntervalAndPlan =
    billingInterval &&
    plan &&
    pricesByBillingIntervalAndPlan[billingInterval] &&
    pricesByBillingIntervalAndPlan[billingInterval][plan];

  return {
    billingInterval,
    conversationalInterval,
    conversationalUpcomingInterval,
    currentPeriodEnd,
    currentPeriodEndFormatted,
    hasActivePartnerTrial,
    plan,
    planFormatted,
    priceByIntervalAndPlan,
    scheduledBillingInterval,
  };
};
